import {
  Breadcrumb,
  Button,
  Divider,
  message,
  PageHeader,
  Form,
  Table,
  Tag,
  Tabs,
  Tooltip,
  Typography,
  Space,
  Modal,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  jobService,
  materialDetailService,
  stockIssueService,
} from "_services";
import TabMenu from "./TabMenu";
import StockSelection from "./StockSelection";

function Material({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [stockItemLoading, setStockItemLoading] = useState(false);
  const [item, setItem] = useState({});
  const [materials, setMaterials] = useState([]);
  const [availableStocksLoading, setIsAvailableStocksLoading] = useState(false);
  const [selectedLineKey, setSelectedLineKey] = useState(null);
  const [activeRequestLine, setActiveRequestLine] = useState(null);
  const [availableStocks, setAvailableStocks] = useState([]);
  const [isStockSelectionVisible, setIsStockSelectionVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [selectedStocks, setSelectedStocks] = useState([]);
  const [selectedMaterialLineKeys, setSelectedMaterialLineKeys] = useState([]);
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const { Text } = Typography;

  useEffect(() => {
    setIsLoading(true);
    jobService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setItem(x.content);
        const allMaterials = x.content.workItems.flatMap((workItem) =>
          workItem.jobTasks.flatMap((task) =>
            task.materials.map((material) => ({
              ...material,
              key: material.id,
              taskNo: task.code,
              workItemNo: workItem.code,
            }))
          )
        );
        setMaterials(allMaterials);
        onFill(x.content);
        handleTabChange(allMaterials[0].key);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, []);

  const handleTabChange = (activeKey) => {
    setActiveTabKey(activeKey.toString());
    setSelectedMaterialLineKeys([activeKey.toString()]);
    setActiveRequestLine(materials.find((line) => line.key === activeKey));
  };

  const handleSearchAndAddStocks = (line) => {
    const stockTypeId = line.material.id;
    //setSelectedStockTypeId(stockTypeId);
    setSelectedLineKey(line.id);
    handleTabChange(line.key);
    //setEnableVerify(false);

    if (stockTypeId) {
      getStocks(stockTypeId);
    } else {
      message.error("Please select valid material type!");
    }
  };

  const getStocks = (stockTypeId) => {
    let searchParams = `?stockTypeId=${stockTypeId}&modes=AVAILABLE&pageNumber=1&pageSize=1000`;

    setIsAvailableStocksLoading(true);
    materialDetailService
      .searchAvailable(searchParams)
      .then((data) => {
        setIsAvailableStocksLoading(false);
        if (data.content.length > 0) {
          setAvailableStocks(data.content);
          setIsStockSelectionVisible(true);
        } else {
          message.info(
            "Sorry, There's no available stocks for the given criteria!"
          );
        }
      })
      .catch((error) => {
        setIsAvailableStocksLoading(false);
        message.error(`${error}`);
      });
  };

  const handleStockSelection = (stockItems) => {
    setSelectedStocks(stockItems);
  };

  const rowSelection = {
    selectedRowKeys: selectedMaterialLineKeys,
    onChange: (selectedMaterialLineKeys) => {
      handleTabChange(selectedMaterialLineKeys[0]);
    },
    /* getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }), */
  };

  const handleAddStocks = () => {
    //const selectedStockIds = new Set(selectedStocks.map((item) => item.id));

    //setStockItemLoading(true);
    if (selectedStocks) {
      materials.forEach((line) => {
        if (line.key === activeTabKey) {
          line.issuedItems = selectedStocks;
        }
      });

      /* requestLine = form
        .getFieldValue("requestLines")
        .find(
          (line) =>
            line.id === activeTabKey &&
            line.stockType.id === selectedStockTypeId
        );
      const stockTypeObj = materialTypes.find(
        (item) => item.id === selectedStockTypeId
      ); */
      /* if (selectedMaterialLine) {
        selectedMaterialLine["issuedItems"] = [
          ...requestLine.requestedItems.filter((item) =>
            ["REQUESTED"].includes(item.mode)
          ),
          ...selectedStocks,
        ];
        requestLine["netWeight"] =
                    selectedStocks.length > 0 &&
                    selectedStocks
                        .map((item) => item.netWeight)
                        .reduce((prev, next) => prev + next);
        requestLine["quantity"] =
          selectedStocks.length > 0 &&
          selectedStocks
            .map((item) => item.quantity)
            .reduce((prev, next) => prev + next);

        setMaterialRequestLines(form.getFieldValue("requestLines"));
        materialRequest.requestLines = form.getFieldValue("requestLines");
        handleTabChange(requestLine.id);
      } */
    }
    //form.setFieldsValue({ stockType: null });
    setMaterials(materials);
    setIsStockSelectionVisible(false);
    setStockItemLoading(false);
    setSelectedStocks([]);
    //console.log("requestLines:", materialRequestLines);
  };

  const getMaterialColumns = () => {
    const lineColumns = [];
    lineColumns.push({
      title: "HS Code",
      key: "materialCode",
      render: (text, record) => {
        return record.material && record.material.code;
      },
    });
    lineColumns.push({
      title: "Company Code",
      key: "materialSecondaryCode",
      render: (text, record) => {
        return record.material && record.material.secondaryCode;
      },
    });
    lineColumns.push({
      title: "Description",
      key: "materialName",
      width: "25%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.material.name}>
            {record.material.name}
          </Tooltip>
        );
      },
    });
    lineColumns.push({
      title: "Task No",
      dataIndex: "taskNo",
      key: "taskNo",
    });
    /* lineColumns.push({
      title: "Work Item",
      dataIndex: "workItemNo",
      key: "workItemNo",
    }); */
    lineColumns.push({
      title: "Required",
      dataIndex: "requiredQuantity",
      key: "requiredQuantity",
      render: (text, record) => {
        return <>{record.requiredQuantity}</>;
      },
    });
    lineColumns.push({
      title: "UOM",
      key: "uom",
      render: (text, record) => {
        return record.uom?.name;
      },
    });
    lineColumns.push({
      title: "Reserved",
      key: "reserved",
    });
    lineColumns.push({
      title: "Issued",
      dataIndex: "issuedQuantity",
      key: "issuedQuantity",
    });
    lineColumns.push({
      title: "Returned",
      dataIndex: "returnedQuantity",
      key: "returnedQuantity",
    });
    lineColumns.push({
      title: "",
      key: "operation",
      //width: "18%",
      render: (text, record) => {
        return (
          <Space size="small">
            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleSearchAndAddStocks(record);
              }}
              //icon={<SearchOutlined />}
              loading={availableStocksLoading && record.key === activeTabKey}
            >
              Stocks
            </Button>
          </Space>
        );
      },
    });

    return lineColumns;
  };

  const getStockItemColumns = () => {
    let columns = [];
    columns.push({
      title: "HS Code",
      dataIndex: "stockType",
      key: "stockType",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Company Code",
      key: "stockType",
      render: (text, record) => {
        return record.stockType.secondaryCode;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Receipt Type",
      dataIndex: "receiptType",
      key: "receiptType",
      render: (text, record) => {
        let color = "";
        if (text === "TIEP") {
          color = "#87d068";
        }
        if (text === "NON_TIEP") {
          color = "#2db7f5";
        }
        if (text === "LOCAL") {
          color = "#108ee9";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Customs Ref No.",
      key: "preReceiptNumber",
      render: (text, record) => {
        return (
          record.stockReceiptLine &&
          record.stockReceiptLine.stockReceipt &&
          record.stockReceiptLine.stockReceipt.customRefNumber
        );
      },
    });
    columns.push({
      title: "Stock Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBin.code;
      },
    });
    columns.push({
      title: "Invoice Date",
      key: "createdAt",
      render: (text, record) => {
        return (
          record.stockReceiptLine &&
          record.stockReceiptLine.stockReceipt &&
          moment(record.stockReceiptLine.stockReceipt.orderDate).format(
            "YYYY-MM-DD"
          )
        );
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      width: "8%",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Issue Quantity",
      //dataIndex: "issueQuantity",
      key: "issueQuantity",
      render: (text, record) => {
        return Number(
          record.issueQuantity ? record.issueQuantity : record.quantity
        );
      },
    });

    return columns;
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        let payload = {};
        payload.store = { id: item.store.id };
        payload.customer = { id: item.store.id };
        payload.storeAddress = { id: item.storeAddress.id };
        payload.stockIssueType = "JOB";
        payload.orderStage = "ISSUED";
        payload.issuedDate = moment().format("YYYY-MM-DD HH:mm:ss");

        payload.issuedLines = materials
          .filter((line) => line.issuedItems?.length > 0)
          .map((line) => ({
            jobMaterial: { id: line.id },
            quantity: line.issuedItems.length,
            stockType: { id: line.material.id },
            issuedItems: line.issuedItems.map((item) => ({
              id: item.id,
              quantity: item.issueQuantity,
            })),
          }));

        console.log("OUT: ", payload);
        //console.log("OUT: ", JSON.stringify(values));
        stockIssueService
          .create(payload)
          .then((data) => {
            setIsLoading(false);
            history.push(`/stock-issue/${data.content.id}/edit`);
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/jobs");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleFormSumbit()}
          key="start-verify"
        >
          <Button
            key="1"
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={
              materials.length > 0 &&
              materials.flatMap((item) => item.issuedItems || []).length == 0
            }
            //onClick={handleFormSumbit}
          >
            Stock Issue
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Job : {item.code}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Materials</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="materials" id={id} />
          {materials.length > 0 && (
            <Table
              bordered
              pagination={false}
              size="small"
              columns={getMaterialColumns()}
              dataSource={materials}
              rowSelection={{
                type: "radio",
                ...rowSelection,
              }}
            />
          )}
          <Modal
            title={`Stocks (${availableStocks.length}) - Required Quantity=${activeRequestLine?.requiredQuantity}`}
            style={{ top: 48 }}
            visible={isStockSelectionVisible}
            okText={`Add Stocks (${selectedStocks.length})`}
            onOk={handleAddStocks}
            onCancel={() => {
              setIsStockSelectionVisible(false);
              setSelectedStocks([]);
            }}
            width={1300}
            destroyOnClose={true}
          >
            <StockSelection
              stocks={availableStocks}
              selectedItems={selectedStocks}
              onSelectChange={handleStockSelection}
            />
          </Modal>
          {materials.length > 0 &&
            materials.flatMap((item) => item.issuedItems || []).length > 0 && (
              <>
                <Divider orientation="left">Stock Items</Divider>
                {/* <Spin tip="Loading..." spinning={stockItemLoading}> */}
                <Tabs defaultActiveKey={materials[0].key}>
                  {materials
                    .filter((line) => line.issuedItems?.length > 0)
                    .map((line, index) => (
                      <Tabs.TabPane
                        tab={`${line.material && line.material.code} (${
                          line.issuedItems && line.issuedItems.length
                        })`}
                        key={index}
                      >
                        <Table
                          bordered
                          size="small"
                          rowKey="id"
                          columns={getStockItemColumns()}
                          dataSource={line.issuedItems}
                          pagination={false}
                          summary={(pageData) => {
                            let totalIssueQuantity = 0;

                            pageData.forEach(({ issueQuantity, quantity }) => {
                              totalIssueQuantity += issueQuantity ? issueQuantity : quantity;
                            });

                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell colSpan={8}>
                                    <Text strong>Total</Text>
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell align="right">
                                    <Text strong>{totalIssueQuantity}</Text>
                                  </Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                          }}
                        />
                      </Tabs.TabPane>
                    ))}
                </Tabs>
                {/* </Spin> */}
              </>
            )}
        </Page>
      </PageHeader>
    </div>
  );
}

export default Material;
